import $ = require('jquery');
import Modul, {OpenConfig, UpdateResponse as ModulUpdateResponse} from './Modul';
import l10n = require('diy/util/l10n');
import features = require('diy/util/features');
import {showDialog as showAviaryShutDownDialog} from 'diy/aviary/DiyAviaryShutdownDialog';
import IframeImageEditorDialog from 'diy/aviary/DiyIframeImageEditorDialog';
import {IframeEditorSaveData} from "diy/aviary/IframeImageEditorDialog";

declare var mm: {
    [moduleId: string]: Modul;
};

declare var modul: {
    galerieFlashUploadReady: typeof FlashUploadReady;
};

declare var cc_: {
    sessionName: any;
    sessionId: any;
};

/**
 * Gallery module
 */

/* Wichtig fuer Galerie-Flash-Upload! */
modul = {
    galerieFlashUploadReady: FlashUploadReady
};
function FlashUploadReady(modulID: string) {
    (mm[modulID] as ModulGallery).upload();
}

interface UpdateResponse extends ModulUpdateResponse {
    galleryview: string;
    imageCount: number;
}

export default class ModulGallery extends Modul {
    CONFIG_MIN_WIDTH = 650;

    imageAmount = 0;
    uploadPending = false;
    cancelUploadPending = false;
    moduleOverlay: JQuery = null;

    loadUebersichtInProgress = false;
    changeThumbSizeInProgress: boolean;
    rotateInProgress: boolean;

    iframeImageEditorDialog: IframeImageEditorDialog;

    hasReachedCriticalLimit() {
        return jimdoData.gallery.limitationEnabled && this.imageAmount >=
            jimdoData.gallery.criticalLimit;
    }

    hasReachedMaximumLimit() {
        return jimdoData.gallery.limitationEnabled && this.imageAmount >=
            jimdoData.gallery.maximumLimit;
    }

    /*
     * Handler for start upload actions
     *
     * @param {jQuery.Event} e
     * @param {string} type - component identifier string
     *
     * @returns {boolean}
     */
    uploadStartHandler(e: JQueryEventObject, type: string) {

        if ("gallery_module" !== type) {
            //ignore actions if not for the current component
            return false;
        }

        let me = e.data;

        //the event is triggered from multiple places; use the type argument to identify the caller
        if ("gallery_module" === type) {
            me.uploadPending = true;
            me.showModuleOverlay();
        }

        return true;
    }

    /*
     * Handles the cancel upload actions
     *
     * @param {jQuery.Event} e
     * @param {string} type - component identifier string
     * @param {mixed} - data to pass to the handler
     *
     * @returns {boolean}
     */
    cancelProgressHandler(e: JQueryEventObject, type: string, data: {moduleId: number}) {

        let me = e.data;
        if ("gallery_module" !== type || ( "object" === typeof data && data.moduleId !== me.moduleId) ) {

            //ignore actions if not for the current component
            return false;
        }

        me.cancelUploadPending = true;
        me.uploadPending = false;

        return true;
    }

    /*
     * Canceled upload action complete handler i.e this is executed
     * right after the all the currently uploaded files were deleted.
     *
     * @param {jQuery.Event} e
     *
     * @return {boolean} true
     */
    cancelActionsCompleteHandler(e: JQueryEventObject) {

        let me = e.data;

        me.hideModuleOverlay();

        me.uploadPending = false;
        me.cancelUploadPending = false;

        /*
         * @see: DHDIYED-446
         * @see: DHDIYED-501
         * Display the uploader after the cancel actions are completed
         */
        me.switchtoupload();
        me.changeView2(7);
        $("#switch_upload_" + me.moduleId).addClass("mod-bar-primary-selected selected");

        return true;
    }

    constructor(moduleId: number) {
        super(moduleId);

        $("#wrapper_slideshow_effect_" + this.moduleId).diy_combobox({ editable: false });
        $("#slideshow_navigation_" + this.moduleId).diy_checkbox();
        $("#slideshow_autostart_" + this.moduleId).diy_checkbox();
        $('#flashview_' + this.moduleId + ' input[type="radio"]').diy_radiobox();

        this.getContentContainer().find('*[data-jsclass][data-jsclass!=""]').generateObject();

        this.getEditorContainer().on('mouseover', '.gallery-gsort img', () => {
            this.initGsort();
        });
        this.initMultipleUploader();
        this.initLimitations();

        this.iframeImageEditorDialog = new IframeImageEditorDialog(
            this.saveEditedImage
        );
    }

    /*
     * Displays a blocking mask over the module controls
     *
     */
    showModuleOverlay() {
        this.moduleOverlay = $("#modul_" + this.moduleId + "_formdiv").loadingBox({useOverlay: true});
    }

    /*
     * Hides the blocking mask set over the module controls
     *
     */
    hideModuleOverlay() {

        if (null !== this.moduleOverlay) {
            this.moduleOverlay.remove();
        }
    }

    /*
     * Handler for the upload completion - it is used to defer the module saving until the upload is completed.
     * On module saving, if the upload is in progress, the saving of the module (triggered by autosave for example)
     * is stopped. After the upload completion is done (signaled by the "diy-editor-gallery-upload-complete" event)
     * the module is saved.
     *
     * (!) Please note that as per requirements, this does not apply for the cancel upload actions: attempting to save
     * a module during an upload cancelation (while files are deleted from server) is a no-op, the action is just
     * ignored i.e autosaving during an upload cancelation is ignored.
     *
     * (!) Please note that this is not always called when an upload is complete; it is called only when a save action
     * was requested
     * during an upload progress if the upload was not canceled. Do not rely on this handler to detect when an upload
     * was completed
     *
     */
    uploadCompleteHandler(e: JQueryEventObject) {

        let me = e.data;

        me.save();
    }

    save() {
        /*
         * Prevents module saving if upload (or upload cancelation) actions are in progress
         */
        if (this.uploadPending || this.cancelUploadPending) {
            return;
        }

        // checks whether the sorting has changed or not
        let updateRequired = this.updateOrderField();
        if (!updateRequired) {
            this.close();
            return;
        }

        $('#flash_delay_' + this.moduleId).val(
        $('#flash_delay_input_' + this.moduleId).val());

        if (this.getAutostartValue()) {
            $('#flash_start_' + this.moduleId).val('1');
        } else {
            $('#flash_start_' + this.moduleId).val('0');
        }

        if (this.getHideBarValue()) {
            $('#html_hidebar_' + this.moduleId).val(0);
        } else {
            $('#html_hidebar_' + this.moduleId).val(1);
        }

        /* Falls Feld nicht, Profifunktion nicht da, also immer auf 1 */
        if (!($('#html_vergroessern_input_' + this.moduleId).length)) {
            $('#html_vergroessern_' + this.moduleId).val('1');
        } else {
            if ($('#html_vergroessern_input_' + this.moduleId)
                    .prop('checked')) {
                $('#html_vergroessern_' + this.moduleId).val('1');
            } else {
                $('#html_vergroessern_' + this.moduleId).val('0');
            }
        }

        if ($('#html_randomimage_input_' + this.moduleId).length > 0
                && $('#html_randomimage_input_' + this.moduleId)
                        .prop('checked')) {
            $('#html_randomimage_' + this.moduleId).val('1');
        } else {
            $('#html_randomimage_' + this.moduleId).val('0');
        }

        //Slideshow Additons
        $("#slideshowEffect_" + this.moduleId).val($("#slideshow_effect_" + this.moduleId).val());
        $("#slideshowAutostart_" + this.moduleId).val($("#slideshow_autostart_" + this.moduleId).val());
        let slideshowChangetime = $("#slideshow_changetime_" + this.moduleId).val();
        /* tslint:disable:triple-equals */
        $("#slideshowChangeTime_" + this.moduleId).val(slideshowChangetime == 0 ? 1 : slideshowChangetime);
        /* tslint:enable:triple-equals */
        $("#slideshowMaxHeight_" + this.moduleId).val($("#slideshow_maxheight_" + this.moduleId).val());

        if ($("#slideshow_navigation_" + this.moduleId).prop('checked')) {
            $("#slideshowNavigation_" + this.moduleId).val('1');
        } else {
            $("#slideshowNavigation_" + this.moduleId).val('0');
        }

        $("#slideshowAutostart_" + this.moduleId).val(
            $("#slideshow_autostart_" + this.moduleId).prop('checked') ? '1' : '0'
        );

        /*
         * Hoehe des Flash proportional setzen Damit die Flash Galerie
         * richtig im Layout dargestellt wird in Proportionen von
         * normalen Fotos Max. 800 Pixel, weil sonst zu hoch (ist
         * Sonderfall nur bei ganz breiten Layouts)
         */
        let flashHeight = Math.floor(this.getContentContainer().width() / 1.33);
        if (flashHeight > 800) {
            flashHeight = 800;
        }
        $('#flashHeight' + this.moduleId).val(flashHeight);
        return super.save();
    }
    remove() {

        this.getContentContainer().find('*[data-jsclass][data-jsclass!=""]').cleanupGeneratedObject();
        super.remove();
    }

    close(userClose?: boolean, cancelEdit?: boolean, isSaving?: boolean, isUserAction?: boolean) {
        /*
         * Events binding cleanup. This is needed due to the fact that are binded at initialization and
         * the initialization can be called multiple times.
         */
        $(document).unbind("diy-editor-cancel-progress",
            this.cancelProgressHandler as (e: JQueryEventObject) => any);
        $(document).unbind("diy-editor-gallery-cancel-complete", this.cancelActionsCompleteHandler);

        super.close(userClose, cancelEdit, isSaving, isUserAction);
    }

    updateModulContent(html: string) {
        //prevent updating module with temporary content (that is in the process of deteletion)
        if (this.cancelUploadPending) {
            return;
        }

        this.getContentContainer().find('*[data-jsclass][data-jsclass!=""]').cleanupGeneratedObject();
        super.updateModulContent(html);
        //Run class_pattern to create specified objects
        this.getContentContainer().find('*[data-jsclass][data-jsclass!=""]').generateObject();
    }
    updateOrderField() {
        let self = this;

        // get the container of items with thumbnail, icons, subtitle, ...
        let sortableImages = $('#gsort_' + self.moduleId);

        /*
         * holds the sorting data for the images
         * <input type="hidden" value="gsort_{id}[]=37&gsort_{id}[]=38&gsort_{id}[]=39" ... />
         */
        let imageOrder = $('#image_order_' + this.moduleId);
        if (imageOrder.get(0) && sortableImages.get(0)) {
            self.initGsort();
            imageOrder.val(sortableImages.sortable('serialize', {}));
            // there is data to save/update
            return true;
        } else {
            // there isn't any data to save
            return false;
        }
    }

    /*
     * Returns the last uploaded images ids.
     *
     * @param {string} html - html markup returned from server that contains all the uploaded
     *                        images ids -  we search for "data-imageId" attributes within this
     *                        markup in order to fetch the uploaded images ids
     *
     * @return {array} - a list containing only the last uploaded images ids
     */
    getLastUploadedImagesIds(html: string) {

        if ("string" !== typeof html) {
            return [];
        }

        let moduleId = this.moduleId;
        let allUploadedImagesIds: number[] = [];
        let previousUploadedCount = $("#gsort_" + moduleId + " a.add-link").length;
        let currentUploadedCount = $("a[data-imageId]", $(html)).length;

        //then retrive all uploaded images ids
        $("a[data-imageId]", $(html)).each(function(index, domElement) {
            allUploadedImagesIds.push(parseInt($(domElement).attr("data-imageId"), 10));
        });

        return allUploadedImagesIds.splice(previousUploadedCount, currentUploadedCount - previousUploadedCount);

    }

    /**
     * Handles the cancel upload actions: delete already uploaded images
     * (keep the previously uploaded images); trigger necessary events
     *
     * @param {array} lastUploadedImagesIds - a list of images ids
     *
     * @returns {boolean}
     *
     */
    cancelUploadActions(lastUploadedImagesIds: number[]) {

        if (!$.isArray(lastUploadedImagesIds)) {
            return false;
        }

        let moduleId = this.moduleId;
        let doc = $(document);
        let uploadCount = lastUploadedImagesIds.length;

        //signal upload cancel start
        doc.trigger("diy-editor-gallery-cancel-start");

        doc.on("diy-editor-gallery-deleted-image", function(e, imageId) {

            if (0 === --uploadCount) {
                doc.trigger("diy-editor-gallery-cancel-complete");
            }
        });

        //delete ONLY the currently uploaded images
        if (lastUploadedImagesIds.length > 0) {

            for (let i = 0; i < lastUploadedImagesIds.length; i++) {
                (mm[moduleId] as ModulGallery).deleteImage(lastUploadedImagesIds[i]);
            }
        } else {
            //no uploaded images: trigger cancel complete event to notify the listeners
            doc.trigger("diy-editor-gallery-cancel-complete");
        }

        return true;
    }

    loadUebersicht() {

        let moduleId = this.moduleId;
        let self = this;
        if (this.loadUebersichtInProgress === false) {
            this.loadUebersichtInProgress = true;
            $.get(systemurl
                    + 'app/module/gallery/overview/moduleId/'
                    + this.moduleId, function(data) {
                let modulJQ = $('#galerieUebersicht_' + moduleId);

                if (self.cancelUploadPending) {
                    self.loadUebersichtInProgress = false;
                    self.cancelUploadActions( self.getLastUploadedImagesIds(data.html) );
                    return;
                }

                modulJQ.html(data.html);
                self.loadUebersichtInProgress = false;

                modulJQ.find('#gsort_' + moduleId).sortable({
                    opacity: 0.7,
                    helper: 'original',
                    tolerance: 'pointer'
                });

                (mm[moduleId] as ModulGallery).addLinkSelector();

                self.imageAmount = data.imageCount;
                self.refreshTooltip();
                self.checkLimitations();
            }, 'json');
        }
    }
    addLinkSelector() {
        let moduleId = this.moduleId;
        this.getEditorContainer().find('.add-link').click(function() {
            let imageId = $(this).attr('data-imageId');
            if (imageId) {
                let inputLinkData = {
                    href: $('#temp_link_' + imageId).val()
                };

                diy.editor.linkSelector.openDialog(inputLinkData, function(outputLinkData) {
                    $('#linkShow' + imageId).val(outputLinkData.value);
                    $('#temp_link_' + imageId).val(outputLinkData.href);
                    $('#temp_link_target_' + imageId).val(outputLinkData.target);
                    (mm[moduleId] as ModulGallery).updateTempData(imageId);
                });
            }
        });
    }
    switchtodetail() {
        $('#switch_detail_' + this.moduleId).hide();
        $('#switch_compact_' + this.moduleId).show();
        $('#switch_upload_' + this.moduleId).removeClass(
                'selected');
        $('#switch_detail_' + this.moduleId).removeClass(
                'selected');
        $('#switch_compact_' + this.moduleId).addClass('selected');
        $('#fileupload_' + this.moduleId).hide();
        $('#gsort_' + this.moduleId).show();
        $('#gsort_' + this.moduleId + ' div.compactview')
                .removeClass('compactview').addClass('detailview');
    }
    switchtocompact() {
        $('#switch_detail_' + this.moduleId).show();
        $('#switch_compact_' + this.moduleId).hide();
        $('#switch_upload_' + this.moduleId).removeClass(
                'selected');
        $('#switch_detail_' + this.moduleId).addClass('selected');
        $('#switch_compact_' + this.moduleId).removeClass(
                'selected');
        $('#fileupload_' + this.moduleId).hide();
        $('#gsort_' + this.moduleId).show();
        $('#gsort_' + this.moduleId + ' div.detailview')
                .removeClass('detailview').addClass('compactview');
    }
    switchtoupload() {
        $('#fileupload_' + this.moduleId).show();

        if ($('#switch_upload_' + this.moduleId).hasClass('selected')) {
            $('#switch_upload_' + this.moduleId).removeClass('selected');
            $('#switch_detail_' + this.moduleId).addClass('selected');
            $('#switch_compact_' + this.moduleId).addClass('selected');
        } else {
            $('#switch_upload_' + this.moduleId).addClass('selected');
            $('#switch_detail_' + this.moduleId).removeClass('selected');
            $('switch_compact_' + this.moduleId).removeClass('selected');
        }
    }
    changeProportion(format: number) {
        /* tslint:disable:triple-equals */
        let oldFormat: number;

        if (format == 1) {
            oldFormat = 2;
        } else {
            oldFormat = 1;
        }

        if ($('#prop_' + this.moduleId + '_' + format).hasClass('selected')) {
            return;
        }
        this.showLoading();
        $('#prop_' + this.moduleId + '_' + format).addClass('selected');
        if (format == 1) {
            $('#prop_' + this.moduleId + '_2').removeClass('selected');
        } else {
            $('#prop_' + this.moduleId + '_1').removeClass('selected');
        }

        this.getEditorContainer().find('.gallery-resize-method').hide();
        this.getEditorContainer().find('.gallery-resize-method[data-method=' + format + ']').show();

        let self = this;
        $.post(systemurl + 'app/module/gallery/changeoptions',
            'moduleId=' + self.moduleId + '&galleryaction=format&format=' + format,
            function(data) {
                mm[self.moduleId].updateModulContent(data.html);
                // rename classes by the thumbnails
                $('#styles_' + self.moduleId + ' a').each(function(i, elem) {
                    let cls = (format == 1 ? 'pro_' : 'sq_') + (i + 1);
                    // set selected item
                    cls += $(elem).hasClass('current') ? ' current' : '';
                    $(elem).attr('class', cls);
                });

                let oldStyle = self.getEditorContainer()
                    .find('.gallery-resize-method[data-method=' + oldFormat + '] a.current')
                    .attr('data-style');
                self.switchtostyle(oldStyle);
                mm[self.moduleId].hideLoading();

            }, 'json');
        /* tslint:enable:triple-equals */
    }
    changeThumbSize(resize: string) {
        let moduleId = this.moduleId;
        let module = mm[moduleId] as ModulGallery;
        if (module.changeThumbSizeInProgress) {
            return;
        }
        module.changeThumbSizeInProgress = true;
        module.showLoading();
        $.post(systemurl + 'app/module/gallery/changeoptions',
            'galleryaction=resize&moduleId=' + moduleId + '&resize=' + resize,
            function(data) {
                module.updateModulContent(data.html);
                module.hideLoading();
                module.changeThumbSizeInProgress = false;
            }, 'json');
    }
    changeHideBar(showBar: number) {
        mm[this.moduleId].showLoading();
        let moduleId = this.moduleId;
        $.post(systemurl + 'app/module/gallery/changeoptions',
            'galleryaction=hideBar&moduleId=' + moduleId + '&hideBar=' + showBar,
            function(data) {
                mm[moduleId].updateModulContent(data.html);
                $('#html_hidebar_' + moduleId).val(showBar);
                mm[moduleId].hideLoading();
            }, 'json');
    }
    getHideBarValue() {
        /* tslint:disable:triple-equals */
        if ($('[name=flash_bar_' + this.moduleId + ']:checked').val() == 1) {
            return 1;
        }
        return 0;
        /* tslint:enable:triple-equals */
    }
    getAutostartValue() {
        /* tslint:disable:triple-equals */
        return $('[name=flash_start_input_' + this.moduleId + ']:checked').val() == 1;
        /* tslint:enable:triple-equals */
    }

    changeView2(view: number) {
        let flashTab = $('#format_' + this.moduleId + '_2');

        if (flashTab.is(':diy-tooltip')) {
            // show the info tooltip for Flash view
            flashTab.diy_tooltip('show');

            // dynamically delegate the sideadmin help action to the gallery tooltip
            flashTab.diy_tooltip('widget').on('click', '.moduleHelpLink',
                $.proxy(guidedAssistant._onModuleHelpLinkClick, guidedAssistant));
        }

        $('#imgtab1-' + this.moduleId).hide();
        $('#flashview_' + this.moduleId).hide();
        $('#slideshow_' + this.moduleId).hide();
        $('#html_' + this.moduleId).hide();

        $('#galleryImage' + this.moduleId).hide();
        $('#upgradeGraphicsBoost' + this.moduleId).hide();

        /*
         * hack for IE8, which does not show the secondary nav bar
         * correctly if not altered after rendering
         */
        $('.module-gallery-file-upload .mod-bar-secondary').hide().show();

        /* tslint:disable:triple-equals */
        if (view == 7) {
            $('#imgtab1-' + this.moduleId).show();
        } else if (view == 8) {
            $('#imgtab2-' + this.moduleId).show();
            $('#galleryImage' + this.moduleId).show();
        } else if (view == 9) {
            $('#imgtab3-' + this.moduleId).show();
            $('#upgradeGraphicsBoost' + this.moduleId).show();
        } else {
            $('#imgtab4-' + this.moduleId).show();
        }
        /* tslint:enable:triple-equals */
    }

    changeView(view: number, loadElements: boolean, randomimage: boolean) {
        $('#fileupload_' + this.moduleId).hide();
        $('#format_' + this.moduleId + '_1, #format_' + this.moduleId + '_2' + ', #format_' + this.moduleId + '_4')
            .removeClass('mod-bar-primary-selected');

        /* tslint:disable:triple-equals */
        if (view == 1 || view == 3) {
            $('#flashview_' + this.moduleId).hide();
            $('#slideshow_' + this.moduleId).hide();
            $('#html_' + this.moduleId).show();

            if (view == 1) {
                $('#format_' + this.moduleId + '_2' + ', #format_' + this.moduleId + '_4')
                    .removeClass('mod-bar-primary-active');
                $('#format_' + this.moduleId + '_1')
                    .addClass('mod-bar-primary-selected').addClass('mod-bar-primary-active');
            } else if (view == 3) {
                // Table - sieht nur Entwickler
                $('#table_' + this.moduleId).show();
                $('#html1_' + this.moduleId).show();
                $('#style_' + this.moduleId).hide();
                $('#props_' + this.moduleId).hide();
                if (randomimage) {
                    $('#format_' + this.moduleId).hide();
                    $('#html_' + this.moduleId).hide();
                    $('#slideshow_' + this.moduleId).hide();
                } else {
                    $('#format_' + this.moduleId).show();
                    $('#html_' + this.moduleId).show();
                }
            }
        } else if (view == 2) {
            $('#format_' + this.moduleId + '_1, #format_' + this.moduleId + '_4').removeClass('mod-bar-primary-active');
            $('#format_' + this.moduleId + '_2')
            .addClass('mod-bar-primary-selected')
            .addClass('mod-bar-primary-active');
            // Flash
            $('#html_' + this.moduleId).hide();
            $('#slideshow_' + this.moduleId).hide();
            $('#flashview_' + this.moduleId).show();
        } else if (view == 4) {
            $('#format_' + this.moduleId + '_1, #format_' + this.moduleId + '_2').removeClass('mod-bar-primary-active');
            $('#format_' + this.moduleId + '_4')
                .addClass('mod-bar-primary-selected')
                .addClass('mod-bar-primary-active');

            $('#html_' + this.moduleId).hide();
            $('#flashview_' + this.moduleId).hide();
            $('#slideshow_' + this.moduleId).show();
        } else {
            $('#html_' + this.moduleId).hide();
            $('#flashview_' + this.moduleId).hide();
            $('#slideshow_' + this.moduleId).hide();
            $('#hinweismaske_' + this.moduleId).hide();
            $('#fileupload_' + this.moduleId).hide();
        }
        /* tslint:enable:triple-equals */

        let self = this;

        $('#format_' + this.moduleId).find('a').each((index, el) => {
            let $el = $(el);
            if ($el.is('#format_' + self.moduleId + '_' + view)) {
                $el.addClass('selected');
            } else {
                $el.removeClass('selected');
            }
        });

        if (loadElements) {
            mm[this.moduleId].showLoading();
            let moduleId = this.moduleId;
            $.post(
                systemurl + 'app/module/gallery/changeoptions',
                'galleryaction=view&moduleId=' + this.moduleId + '&view=' + view +
                '&width=' + Math.floor(this.getContentContainer().width()) + '&updated=yes',
                function(data) {
                    mm[moduleId].updateModulContent(data.html);
                    mm[moduleId].hideLoading();
                },
                'json'
            );
        }
    }
    adjustConfigView(hasConfigView: boolean) {
        super.adjustConfigView(hasConfigView);
        this.refreshTooltip();
    }

    showTitle() {
        $('#hinweismaske_' + this.moduleId).toggle();
    }

    deleteImage(bildID: number) {
        let self = this;
        let url = systemurl + 'app/module/gallery/changeoptions';
        $.post(url, {
                galleryaction : 'delete',
                imageId : bildID,
                moduleId : this.moduleId
            }, function(data) {
                /*
                * oleg: "If it is flash gallery we need to reiject html to
                * update the gallery - stupid but I have no time"
                */

                //signal deletion completed
                $(document).trigger("diy-editor-gallery-deleted-image", bildID);

                /*
                * Prevent displaying the images that that are in the process of being deleted
                * data.html - is retrived with each delete/ call from the server and it returns the current
                *             images state on the server i.e returns even the images that are in the
                                process of being
                *             deleted but havent been yet (an action which is in progress at the present).
                */
                if (self.cancelUploadPending) {
                   return;
                }

                self.updateModulContent(data.html);
                $('#gsort_' + self.moduleId + '_' + bildID + ', #gallery_thumb_' + bildID)
                    .fadeOut(400, function() {
                        $(this).remove();
                    });
                self.imageAmount = data.imageCount;
                self.refreshTooltip();
                self.checkLimitations();
            },
            'json'
        );
    }

    editImage(bildID: number) {
        let self = this;

        if (features('iframedImageEditor')) {
            $.ajax({
                "url": '/app/cms/picturemanipulation/getgalleryimageurl/',
                "type": 'POST',
                "data": {
                    "load": {moduleId: self.moduleId, imageId: bildID}
                },
                "success": function (response) {
                    self.iframeImageEditorDialog.showDialog(
                        {moduleId: self.moduleId, imageId: bildID},
                        response.imageUrl,
                        response.originalImageUrl
                    );
                }
            });

        } else if (features('aviaryShutdown')) {
            showAviaryShutDownDialog();

        } else if (diy.editor.imageManipulation) {
            diy.editor.imageManipulation.show({load: {moduleId: this.moduleId, imageId: bildID}});
        }
    }

    saveEditedImage = function(data: IframeEditorSaveData) {
        $.ajax({
            "url": '/app/cms/picturemanipulation/saveeditedimage',
            "type": 'POST',
            "data": {
                load: {moduleId: data.payload.moduleId, imageId: data.payload.imageId},
                imageDataUrl: data.imageDataUrl
            },
            "success": function(response) {
                if ("object" === typeof response && response.hasOwnProperty("moduleId")) {
                    mm[response.moduleId].viewUpdateCallback(response.moduleId);
                }
            },
            "error": function() {
                $(window).humanMsg(l10n.getString('timout'));
            }
        });
    };

    upload() {
        let moduleId = this.moduleId;
        let self = this;

        $.post(
            systemurl + 'app/module/gallery/changeoptions',
            { 'galleryaction' : 'nothing', 'moduleId' : moduleId },
            function(data) {
                data = JSON.parse(data);
                mm[moduleId].updateModulContent(data.html);
                self.loadUebersichtInProgress = false;
                self.loadUebersicht();
            }
        );
        $('#fileupload_' + moduleId).toggle();
        $('#switch_upload_' + moduleId).removeClass('mod-bar-primary-selected');
        $('#gallery_gfxboost_' + moduleId).removeClass('mod-bar-primary-selected');
    }
    rotate(imageId: number, degree: number) {
        if (this.rotateInProgress) {
            return;
        }
        this.rotateInProgress = true;
        this.showConfigLoading();
        let self = this;
        $.post(systemurl + 'app/module/gallery/changeoptions',
                'galleryaction=rotate&imageId=' + imageId
                        + '&moduleId=' + this.moduleId + '&degree='
                        + degree, function() {
                    let $img = $('#gsort_' + self.moduleId + '_'
                            + imageId + ' img');
                    $img.attr('src', $img.attr('src') + 1);
                    self.hideConfigLoading();
                    self.rotateInProgress = false;
                });
    }
    togglestyle() {
        $('#gallerystyle_' + this.moduleId).toggle();
        if ($('#button_styles_' + this.moduleId).hasClass(
                'selected')) {
            $('#button_styles_' + this.moduleId).removeClass(
                    'selected');
        } else {
            $('#button_styles_' + this.moduleId).addClass(
                    'selected');
        }
    }
    /**
     * Switch the gallery style (with borders, without borders, spaced,etc)
     */
    switchtostyle (style: string) {
        let currentProportion = this.getEditorContainer()
            .find('a[data-proportion].selected')
            .attr('data-proportion');
        let self = this;

        if ($('#style_' + currentProportion + '_' + this.moduleId + '_' + style).hasClass(
                'current')) {
            return;
        }

        $.post(systemurl + 'app/module/gallery/changeoptions',
            { 'galleryaction' : 'style', 'style' : style, 'moduleId' : this.moduleId },
            function (data) {
                data = JSON.parse(data);
                self.getContentContainer().html(data.html);
            }
        );

        $('#gallerystyle_' + this.moduleId).find('a').each(function(index) {
            if ((index + 1) === parseInt(style, 10)) {
                $('#style_' + currentProportion + '_' + self.moduleId + '_' + (index + 1)).addClass('current');
            } else {
                $('#style_' + currentProportion + '_' + self.moduleId + '_' + (index + 1)).removeClass('current');
            }
        });
    }
    open(e?: OpenConfig) {

        /*
         * Set upload actions
         *
         * These events are unbinded (cleaned up)in the close() method in order to avoid executing them multiple
         * times in the case the module was initialized more than one time.
         */
        $(document).bind("diy-editor-cancel-progress", this, this.cancelProgressHandler as () => any);
        $(document).bind("diy-editor-gallery-cancel-complete", this, this.cancelActionsCompleteHandler);

        this.switchtoupload();
        this.changeView2(7);
        super.open(e);
        this.loadUebersicht();
        $('#switch_upload_' + this.moduleId).click();
    }
    updateTempData(bildId: string) {
        $('#link_' + bildId).val($('#temp_link_' + bildId).val());
        $('#link_target_' + bildId).val($('#temp_link_target_' + bildId).val());
    }
    afterViewUpdate(response: UpdateResponse) {
        let modulJQ = $('#galerieUebersicht_' + this.moduleId);
        modulJQ.html(response.galleryview);
        $('#fileupload_' + this.moduleId).hide();
        $('#gallery_gfxboost_' + this.moduleId).removeClass('mod-bar-primary-selected');

        this.addLinkSelector();
        this.imageAmount = response.imageCount;
        this.refreshTooltip();
        this.checkLimitations();
    }

    refreshTooltip() {
        let tooltipTarget = $('#format_' + this.moduleId + '_2');

        if (tooltipTarget.is(':diy-tooltip')) {
            tooltipTarget.diy_tooltip('refresh');
        }
    }

    /**
     * Set up the sortable list of images in the gallery.
     */
    initGsort() {
        if (!$('#gsort_' + this.moduleId).hasClass('ui-sortable')) {
            $('#gsort_' + this.moduleId).sortable({
                opacity: 0.7,
                helper: 'original',
                tolerance: 'pointer'
            });
        }
    }

    /**
     * Set up the flash multiple uploader and upload params.
     */
    initMultipleUploader() {
        // attach behaviour for dynamically added help links
        this.getEditorContainer().on('click', 'a.moduleHelpLink', function(e) {
            $.proxy(guidedAssistant._onModuleHelpLinkClick, guidedAssistant)(e);
        });
    }

    /**
     * Initialize the containers for possible image limitations messages.
     */
    initLimitations() {
        let config = this.getEditorContainer();
        let softLimitEl = config.find('.image-soft-limit-msg');
        let hardLimitEl = config.find('.image-hard-limit-msg');

        if (!jimdoData.gallery.limitationEnabled) {
            return;
        }

        softLimitEl.html('');

        hardLimitEl.diy_simpleTooltip({
            triggerMode: 'none',
            positionMode: 'static',
            appendTo: hardLimitEl
        }).diy_simpleTooltip('option', {
            cls: 'diy-alert-tooltip diy-error-tooltip diy-icon-tooltip',
            contentIcon: 'ui-icon-alert'
        }).diy_simpleTooltip('hide');
    }

    /**
     * Check current number of images in the gallery.
     * Warn about the soft limit or enforce the hard limit if the case.
     */
    checkLimitations() {
        let self = this;
        let moduleId = this.moduleId;
        let softLimitEl = this.getEditorContainer().find('.image-soft-limit-msg');
        let hardLimitEl = this.getEditorContainer().find('.image-hard-limit-msg');

        let softMsg = l10n.getString('limitations.warningAmountImagesPerGallery')
            .replace('{softlimit}', "" + jimdoData.gallery.criticalLimit)
            .replace('{hardlimit}', "" + jimdoData.gallery.maximumLimit);
        let hardMsg = l10n.getString('limitations.maxAmountImagesPerGallery')
            .replace('{hardlimit}', "" + jimdoData.gallery.maximumLimit);

        if (!jimdoData.gallery.limitationEnabled) {
            return;
        }

        // handle the soft (critical) limit
        softLimitEl.html(this.hasReachedCriticalLimit() && !this.hasReachedMaximumLimit() ? softMsg : '');

        // handle the hard (maximum) limit
        this.getEditorContainer().find('#insertImages').button(this.hasReachedMaximumLimit() ? 'disable' : 'enable');
        hardLimitEl
            .diy_simpleTooltip('option', 'content', this.hasReachedMaximumLimit() ? hardMsg : '')
            .diy_simpleTooltip(this.hasReachedMaximumLimit() ? 'show' : 'hide');

        // attach a callback to the oao-widgetloaded grafx event for toggling the insert button in grafx;
        // match the image library tab and the purchased images tab
        let tabsSelector = '#1and1-external-' + moduleId + ', #1and1-external-purchased-' + moduleId;

        this.getEditorContainer()
            .off('oao-widgetloaded', tabsSelector)
            .on('oao-widgetloaded', tabsSelector, (function() {
                return function() {
                    self.getEditorContainer().find('#insertImages')
                        .button(self.hasReachedMaximumLimit() ? 'disable' : 'enable');
                };
            })());
    }
    startFileManager() {

        /* the default number of images that can be selected */
        let moduleSources = {};
        let self = this;
        let maxSelection = jimdoData.gallery.maximumLimit;
        let alreadyExisting = this.imageAmount || 0;

        let insertStorageItems = function(
            items: any[],
            succClb: (response: any) => void,
            errClb: (response: any) => void
        ) {
            $.ajax({
                type: 'POST',
                url: '/app/module/gallery/link-storage-files',
                data: {
                    moduleId: self.moduleId,
                    storageFileIds: items.map(function(item) {
                        return item.getId();
                    })
                },
                success: function(response, status, jqXHR) {
                    if (response.success) {
                        succClb(response);
                    } else {
                        errClb(response);
                    }
                },
                error: function(jqXHR, status, errorThrown) {
                    errClb(errorThrown);
                }
            });
        };

        let insertCmsItems = function (
            items: any[],
            successCb: (response: any) => void,
            errorCb: (response: any) => void
        ) {
            $.ajax({
                type: 'POST',
                url: '/app/module/gallery/import-cms-images',
                data: {
                    moduleId: self.moduleId,
                    cmsImageIds: items.map(function(item) {
                        return item.getId();
                    })
                },
                success: function(response, status, jqXHR) {
                    if (response.success) {
                        successCb(response);
                    } else {
                        errorCb(response);
                    }
                },
                error: function(jqXHR, status, errorThrown) {
                    errorCb(errorThrown);
                }
            });

        };

        moduleSources = {
            storage: {
                batchSize: 10,
                callback: insertStorageItems
            },
            cms: {
                batchSize: 1,
                callback: insertCmsItems
            },
            bigstock: {
                batchSize: 1,
                callback: insertStorageItems
            },
            '123rf': {
                batchSize: 1,
                callback: insertStorageItems
            }
        };

        (diy as any).editor.filemanager = new (diy as any).editor.Filemanager({
            appName: 'filemanager',
            mode: 'selection',
            maxSelection: maxSelection,
            alreadyExisting: alreadyExisting,
            sources: moduleSources,
            callback: function(report: any) {
                if (report.successItems.length > 0) {
                    self.viewUpdateCallback(self.moduleId);
                } else {
                    // TODO check if some error handling have to be done here
                }
            }
        });

    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulGallery.ts
 **/